import * as React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

export interface LinkListTertiaryItemProps {
  link: string;
  title: string;
  iconName?: string;
}

const LinkListTertiaryItem: React.FC<LinkListTertiaryItemProps> = (props) => {
  const {
    link,
    title,
    iconName = 'chevron_right',
  } = props;

  return (
    <li className="LinkList__TertiaryItem">
      <CoreLink href={link}>
        <Icon name={iconName} />
        <span className="LinkList__TertiaryItem__title">{title}</span>
      </CoreLink>
    </li>
  );
};

export default LinkListTertiaryItem;
